import {
  styled,
  Dialog,
  dialogClasses,
  DialogContent,
  DialogActions,
  tableBodyClasses,
  tableRowClasses,
  Chip,
  chipClasses,
} from '@mui/material';
import { TabPanel } from '@mui/lab';

import Table from '~components/Table';
import { TableProps } from '~components/Table/types';
import { AdminIntegration } from '~services/admin/integration/types';

export const DialogImportOrdersFromIntegrationContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    width: '100%',
    minHeight: 626,
    maxWidth: 800,
  },
});

export const DialogImportOrdersFromIntegrationLoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  flex: 1,
});

export const DialogImportOrdersFromIntegrationContentContainer = styled(
  DialogContent,
)({
  display: 'flex',
  flex: 1,
});

export const DialogImportOrdersFromIntegrationLabelImg = styled('img', {
  shouldForwardProp: (prop) =>
    prop !== 'size' && prop !== 'rounded' && prop !== 'eleveation',
})<{
  size?: 'small' | 'medium' | 'large';
  rounded?: boolean;
  elevation?: number;
}>(({ size = 'medium', rounded = false, elevation = 0, theme }) => ({
  width: 250,
  boxShadow: theme.shadows[elevation],

  ...(rounded && {
    borderRadius: '50%',
  }),

  ...(size === 'small' && {
    width: 90,
  }),

  ...(size === 'large' && {
    width: 600,
  }),
}));

export const DialogImportOrdersFromIntegrationTabPanel = styled(TabPanel)({
  display: 'flex',
  padding: 0,
  flex: 1,
});

export const DialogImportOrdersFromIntegrationActions = styled(DialogActions)({
  justifyContent: 'space-between',
});

export const DialogImportOrdersFromIntegrationTable = styled(
  (props: TableProps<AdminIntegration>) => <Table {...props} />,
)({
  [`& .${tableBodyClasses.root} .${tableRowClasses.root}`]: {
    height: 66.13,
  },
});

export const DialogImportOrdersFromIntegrationTableChip = styled(Chip)(
  ({ theme }) => ({
    [`& .${chipClasses.label}`]: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      // maxWidth: 80,
    },
    [`& .${chipClasses.icon}`]: {
      fontSize: theme.typography.pxToRem(14),
    },
  }),
);
